import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, Search, Building2, Bookmark, LogOut, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NotificationBell } from "@/components/NotificationBell";

const links = [
  { to: "/app", label: "Le mie aziende", icon: Building2, testid: "nav-dashboard", end: true },
  { to: "/app/riepilogo", label: "Riepilogo", icon: LayoutDashboard, testid: "nav-riepilogo" },
  { to: "/app/preferiti", label: "Preferiti", icon: Bookmark, testid: "favorites-nav-tab" },
];

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <NavLink to="/app" className="flex items-center gap-2" data-testid="navbar-logo">
          <img src="/logo-atb.png" alt="A Tutto Bando" className="h-9 w-9 rounded-xl" />
          <span className="font-display text-lg font-bold tracking-tight text-slate-900">
            A Tutto<span className="text-indigo-600"> Bando</span>
          </span>
        </NavLink>

        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${
                  isActive
                    ? "bg-slate-900 text-white"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              <l.icon className="h-4 w-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <NotificationBell />
          <span className="hidden text-sm font-medium text-slate-500 sm:inline" data-testid="navbar-user-email">
            {user?.email}
          </span>
          <Button
            variant="outline"
            size="sm"
            onClick={handleLogout}
            data-testid="navbar-logout-button"
            className="gap-2"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Esci</span>
          </Button>
        </div>
      </div>

      {/* mobile nav */}
      <nav className="flex items-center gap-1 overflow-x-auto border-t border-slate-100 px-3 py-2 md:hidden">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            data-testid={`${l.testid}-mobile`}
            className={({ isActive }) =>
              `flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors ${
                isActive ? "bg-slate-900 text-white" : "text-slate-600"
              }`
            }
          >
            <l.icon className="h-4 w-4" />
            {l.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
